import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSizeAndWidthContext } from '../context';

export function useEmailMeWhenInStockForm(userEmail: string | undefined) {
  const { selectedSize, selectedWidth } = useSizeAndWidthContext();

  const {
    handleSubmit,
    register,
    formState: { errors: validationErrors, isSubmitting, isSubmitSuccessful, touchedFields },
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      email: '',
    },
    mode: 'onChange',
  });

  useEffect(() => {
    // pre-fill email for logged-in users once it is fetched from the API
    if (!touchedFields.email && userEmail) {
      setValue('email', userEmail);
    }
  }, [setValue, touchedFields.email, userEmail]);

  useEffect(() => {
    // reset form when the user changes the selected size or width
    reset({ email: userEmail || '' });
  }, [selectedSize, selectedWidth, reset, userEmail]);

  return {
    handleSubmit,
    register,
    validationErrors,
    isSubmitting,
    isSubmitSuccessful,
    reset,
  };
}
